import { useState, useEffect } from 'react';

const TOUR_COMPLETED_KEY = 'scarlet-sync-tour-completed';
const TOUR_DISMISSED_KEY = 'scarlet-sync-tour-dismissed';
const TOUR_SHOWN_KEY = 'scarlet-sync-tour-shown';

export function useOnboardingTour() {
  const [showTour, setShowTour] = useState(false);
  const [hasCompletedTour, setHasCompletedTour] = useState(false);
  const [hasDismissedTour, setHasDismissedTour] = useState(false);
  const [hasShownTour, setHasShownTour] = useState(false);

  useEffect(() => {
    // Check if user has completed, dismissed, or shown the tour
    const completed = localStorage.getItem(TOUR_COMPLETED_KEY) === 'true';
    const dismissed = localStorage.getItem(TOUR_DISMISSED_KEY) === 'true';
    const shown = localStorage.getItem(TOUR_SHOWN_KEY) === 'true';
    
    setHasCompletedTour(completed);
    setHasDismissedTour(dismissed);
    setHasShownTour(shown);

    // Only show tour for completely new users who haven't seen it at all
    if (!completed && !dismissed && !shown) {
      // Small delay to ensure the page is fully loaded
      const timer = setTimeout(() => {
        setShowTour(true);
        // Mark that tour has been shown (even if not completed)
        localStorage.setItem(TOUR_SHOWN_KEY, 'true');
      }, 1000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const completeTour = () => {
    localStorage.setItem(TOUR_COMPLETED_KEY, 'true');
    setHasCompletedTour(true);
    setShowTour(false);
  };

  const dismissTour = () => {
    localStorage.setItem(TOUR_DISMISSED_KEY, 'true');
    setHasDismissedTour(true);
    setShowTour(false);
  };

  const resetTour = () => {
    localStorage.removeItem(TOUR_COMPLETED_KEY);
    localStorage.removeItem(TOUR_DISMISSED_KEY);
    localStorage.removeItem(TOUR_SHOWN_KEY);
    setHasCompletedTour(false);
    setHasDismissedTour(false);
    setHasShownTour(false);
    setShowTour(true);
  };

  const shouldShowTour = showTour && !hasCompletedTour && !hasDismissedTour && !hasShownTour;

  return {
    showTour: shouldShowTour,
    hasCompletedTour,
    hasDismissedTour,
    hasShownTour,
    completeTour,
    dismissTour,
    resetTour
  };
}
